export default {
    sync_entities_title: "Sync Data to Zonar",
    sync_entities_account: "Account",
    sync_entities_units: "Units",
    sync_entities_subusers: "Subusers",
    sync_entities_drivers: "Drivers",
    sync_entities_assets: "Assets",
    sync_entities_asset_subtypes: "Asset Subtypes",
    sync_entities_process: "Process",
    sync_entities_entities_to_sync: "Entities to Sync",
    sync_entities_success_messages: "Entity synchronization request has been received. Click here to view the synchronization status",
    sync_entities_error_messages: "Entities could not be synchronized",
    sync_entities_asset_types: "Asset Types",
    sync_entities_selected_for: "At least one entity must be selected for",
    sync_entities_all: "All",
    sync_entities_selected: "Selected",
};